import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import CoolCats from '../../api/contract'
import { numSpaces } from '../../utils/functions'

import { NoWalletState } from '../../components/NoWalletState/NoWalletState'
import { Button } from '../../components/Button/Button'

import './Profile.scss'

export const Profile = () => {
  const wallet = useSelector((state) => state.wallet);
  const [walletConnected, setWalletConnected] = useState(false);
  const [user, setUser] = useState(null);
  const [walletLock, setWalletLock] = useState(false);
  const [contract, setContract] = useState(null);

  useEffect(() => {
		let isMount = true

		if (window.tronWeb && wallet.data.auth) {
			setWalletConnected(true);

      new CoolCats()
					.init(window.tronWeb)
					.then((c) => {
						if (isMount) {
              c.getUser(wallet.data.address)
                .then(user => setUser(user))
                .catch(console.log);
              
              setContract(c);
            }
					})
		}

		return () => (isMount = false)
	}, [wallet, setWalletConnected, setUser])

  const withdrawTRX = async () => {
    if (contract && user && user.wallet > 0) {
      setWalletLock(true);
      contract.withdrawReward().then(() => {
        return contract.getUser(wallet.data.address)
      })
      .then(user => setUser(user))
      .catch(console.log)
      .finally(() => setWalletLock(false));
    }
  }

  return (
    <div className="profile-container">
      {
        walletConnected
        && (
          <div className="profile-header">
            <h1>您的个人资料</h1>
          </div>
        )
      }
      {walletConnected
      ? (
        <div className="profile-data">
          <div className="profile-info">
            <div className="row">
              <span className="stat-label">
                名字
              </span>
              <div className="dotted-line"></div>
              <span className="stat-value">
                {wallet.data.name ?? 'Unknown'}
              </span>
            </div>
            <div className="row">
              <span className="stat-label">
                地址
              </span>
              <div className="dotted-line"></div>
              <span className="stat-value">
                {wallet.data.address}
              </span>
            </div>
            <div className="row">
              <span className="stat-label">
                收支余额
              </span>
              <div className="dotted-line"></div>
              <span className="stat-value">
                {((wallet.data.balance || '0') || '0') + ' TRX'}
              </span>
            </div>
            <div className="row">
              <span className="stat-label">
                总计铸造
              </span>
              <div className="dotted-line"></div>
              <span className="stat-value">
                {user ? user.mintedCount || '0' : '0'}
              </span>
            </div>
            <div className="row">
              <span className="stat-label">
                水平
              </span>
              <div className="dotted-line"></div>
              <span className="stat-value">
                {user ? user.level || '0' : '0'}
              </span>
            </div>
            <div className="row">
              <span className="stat-label">
                总计TRX在pool
              </span>
              <div className="dotted-line"></div>
              <span className="stat-value">
                {user && user.wallet && user.wallet > 0 ? numSpaces(user.wallet / 1000000) : 0}
              </span>
            </div>
          </div>
          <Button
            label="POOL에서 인출하기"
            color="blue"
            small
            disabled={!(user && user.wallet > 0 && !walletLock)}
            onClick={withdrawTRX}
          />
        </div>
      )
      : <NoWalletState />}
    </div>
  )
}